import { Box } from '@mui/material'
import React from 'react'
import { MastersManagementToolSelect } from 'shared/ui'
import { mastersMenuOptions } from './utility'

// Works with all masters as a group
export function MastersManagement() {
  return (
    <Box>
      <Box>Masters Management</Box>
      <MastersManagementToolSelect components={mastersMenuOptions} />
    </Box>
  )
}
